import { explode } from "src/utility";
import { useJourneyStaticDetails } from "../../../../context";
import { useSSRContext } from "../../context/SSRContext";
import { generateMealOptions, getMealLabel } from "../../utils";
import ItemSelection from "../ItemSelection/ItemSelection";
import PassengerDeclaration from "../PassengerDecleration";

export default function MealSelection() {
  const { cursor, flightOptions } = useSSRContext();
  const { journeyDetails } = useJourneyStaticDetails();
  const { data } = explode(journeyDetails, {});
  const flightSelected = flightOptions.find((option) => option.value === cursor.flightId);
  const mealOptions = generateMealOptions(flightSelected, data?.ssr?.mealDynamic);
  const items = mealOptions?.map((meal) => ({
    option: meal,
    label: getMealLabel(meal),
    price: meal.price,
    currency: meal.currency,
  }));

  return (
    <div className="flex flex-col gap-4">
      <PassengerDeclaration />
      <ItemSelection ssrType="meals" trackLabel="Meal" items={items} className="bg-background-default grid-cols-1 rounded-md md:grid-cols-2" />
    </div>
  );
}
